import useGetNewsTipTableColumns from './useGetNewsTipTableColumns'

export default useGetNewsTipTableColumns
